import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "options-list texture-options futa-no-ura" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormOption = _resolveComponent("FormOption")!
  const _component_FormColorPicker = _resolveComponent("FormColorPicker")!
  const _component_FormScrollableTab = _resolveComponent("FormScrollableTab")!

  return (_openBlock(), _createBlock(_component_FormScrollableTab, {
    class: "futanoura-content",
    index: _ctx.index,
    configName: _ctx.configName
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
          return (_openBlock(), _createBlock(_component_FormOption, {
            optionType: 'texture',
            key: item.id,
            option: item,
            onClick: ($event: any) => (_ctx.onClick(item)),
            isSelected: _ctx.config == item.id
          }, null, 8, ["option", "onClick", "isSelected"]))
        }), 128)),
        (_ctx.showColorPicker)
          ? (_openBlock(), _createBlock(_component_FormColorPicker, {
              key: 0,
              onUpdatePicker: _ctx.onColorPickerUpdate,
              color: _ctx.colorpicker
            }, null, 8, ["onUpdatePicker", "color"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["index", "configName"]))
}